module.exports = __webpack_public_path__ + "static/media/dashboard.a7d7d9dd.png";